import { styled } from '@mui/material';

import { TextField } from '../Inputs';

export const StyledTextField = styled(TextField)(({ theme: { palette, breakpoints } }) => ({
  '& .MuiInputBase-readOnly': {
    borderColor: palette.grey[300],
    backgroundColor: palette.grey[25],
  },
  // Read-only still takes focus, and iOS zooms into any focused field under 16px.
  [breakpoints.down('sm')]: {
    '& .MuiInputBase-input': { fontSize: 16 },
  },
}));
